import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import {
  GLOBAL_STATE,
  SD_FEEDBACK_EVALUATION_BY_EVALUATOR,
  SD_FEEDBACK_EVALUATION_BY_SUBJECT,
  SD_FEEDBACK_EVALUATION_CAMPAIGN_CURRENT,
  SD_FEEDBACK_EVALUATION_CREATE,
  SD_FEEDBACK_EVALUATION_EVALUATE_INFO,
  SD_FEEDBACK_EVALUATION_STATS,
  SD_FEEDBACK_EVALUATION_STATS_OPEN_ENDED,
  SD_FEEDBACK_QUESTION_ALL,
  SD_FEEDBACK_RESPONSE_ALL,
  SD_FEEDBACK_STAFF_ASSIGNED_EVALUATORS_ALL,
  SD_FEEDBACK_STAFF_ASSIGN_CREATE,
  SD_FEEDBACK_STAFF_ASSIGN_PRINCIPAL_LIST,
  SD_FEEDBACK_STAFF_ASSIGN_STAFF_LIST,
  SD_FEEDBACK_STAFF_ASSIGN_SUBJECT_ALL,
} from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const SD_FEEDBACK = GLOBAL_STATE

const sdFeedbackSlice = createSlice({
  name: SD_FEEDBACK,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.sdFeedbackEvaluationCreate.pending, state => {
        state[SD_FEEDBACK_EVALUATION_CREATE].loading = true
      })
      .addCase(actionCreators.sdFeedbackEvaluationCreate.rejected, (state, action) => {
        state[SD_FEEDBACK_EVALUATION_CREATE].loading = false
        state[SD_FEEDBACK_EVALUATION_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.sdFeedbackEvaluationCreate.fulfilled, (state, action) => {
        state[SD_FEEDBACK_EVALUATION_CREATE].loading = false
        state[SD_FEEDBACK_EVALUATION_CREATE].error = null
        state[SD_FEEDBACK_EVALUATION_CREATE].data = action.payload
      })

    builder
      .addCase(actionCreators.sdFeedbackEvaluationByEvaluator.pending, state => {
        state[SD_FEEDBACK_EVALUATION_BY_EVALUATOR].loading = true
      })
      .addCase(actionCreators.sdFeedbackEvaluationByEvaluator.rejected, (state, action) => {
        state[SD_FEEDBACK_EVALUATION_BY_EVALUATOR].loading = false
        state[SD_FEEDBACK_EVALUATION_BY_EVALUATOR].error = action.payload as AxiosError
      })
      .addCase(actionCreators.sdFeedbackEvaluationByEvaluator.fulfilled, (state, action) => {
        state[SD_FEEDBACK_EVALUATION_BY_EVALUATOR].loading = false
        state[SD_FEEDBACK_EVALUATION_BY_EVALUATOR].error = null
        state[SD_FEEDBACK_EVALUATION_BY_EVALUATOR].data = action.payload
      })

    builder
      .addCase(actionCreators.sdFeedbackEvaluationBySubject.pending, state => {
        state[SD_FEEDBACK_EVALUATION_BY_SUBJECT].loading = true
      })
      .addCase(actionCreators.sdFeedbackEvaluationBySubject.rejected, (state, action) => {
        state[SD_FEEDBACK_EVALUATION_BY_SUBJECT].loading = false
        state[SD_FEEDBACK_EVALUATION_BY_SUBJECT].error = action.payload as AxiosError
      })
      .addCase(actionCreators.sdFeedbackEvaluationBySubject.fulfilled, (state, action) => {
        state[SD_FEEDBACK_EVALUATION_BY_SUBJECT].loading = false
        state[SD_FEEDBACK_EVALUATION_BY_SUBJECT].error = null
        state[SD_FEEDBACK_EVALUATION_BY_SUBJECT].data = action.payload
      })

    builder
      .addCase(actionCreators.sdFeedbackResponseAll.pending, state => {
        state[SD_FEEDBACK_RESPONSE_ALL].loading = true
      })
      .addCase(actionCreators.sdFeedbackResponseAll.rejected, (state, action) => {
        state[SD_FEEDBACK_RESPONSE_ALL].loading = false
        state[SD_FEEDBACK_RESPONSE_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.sdFeedbackResponseAll.fulfilled, (state, action) => {
        state[SD_FEEDBACK_RESPONSE_ALL].loading = false
        state[SD_FEEDBACK_RESPONSE_ALL].error = null
        state[SD_FEEDBACK_RESPONSE_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.sdFeedbackStaffAssignCreate.pending, state => {
        state[SD_FEEDBACK_STAFF_ASSIGN_CREATE].loading = true
      })
      .addCase(actionCreators.sdFeedbackStaffAssignCreate.rejected, (state, action) => {
        state[SD_FEEDBACK_STAFF_ASSIGN_CREATE].loading = false
        state[SD_FEEDBACK_STAFF_ASSIGN_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.sdFeedbackStaffAssignCreate.fulfilled, (state, action) => {
        state[SD_FEEDBACK_STAFF_ASSIGN_CREATE].loading = false
        state[SD_FEEDBACK_STAFF_ASSIGN_CREATE].error = null
        state[SD_FEEDBACK_STAFF_ASSIGN_CREATE].data = action.payload
      })

    builder
      .addCase(actionCreators.sdFeedbackStaffAssignPrincipalList.pending, state => {
        state[SD_FEEDBACK_STAFF_ASSIGN_PRINCIPAL_LIST].loading = true
      })
      .addCase(actionCreators.sdFeedbackStaffAssignPrincipalList.rejected, (state, action) => {
        state[SD_FEEDBACK_STAFF_ASSIGN_PRINCIPAL_LIST].loading = false
        state[SD_FEEDBACK_STAFF_ASSIGN_PRINCIPAL_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.sdFeedbackStaffAssignPrincipalList.fulfilled, (state, action) => {
        state[SD_FEEDBACK_STAFF_ASSIGN_PRINCIPAL_LIST].loading = false
        state[SD_FEEDBACK_STAFF_ASSIGN_PRINCIPAL_LIST].error = null
        state[SD_FEEDBACK_STAFF_ASSIGN_PRINCIPAL_LIST].data = action.payload
      })

    builder
      .addCase(actionCreators.sdFeedbackStaffAssignStaffList.pending, state => {
        state[SD_FEEDBACK_STAFF_ASSIGN_STAFF_LIST].loading = true
      })
      .addCase(actionCreators.sdFeedbackStaffAssignStaffList.rejected, (state, action) => {
        state[SD_FEEDBACK_STAFF_ASSIGN_STAFF_LIST].loading = false
        state[SD_FEEDBACK_STAFF_ASSIGN_STAFF_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.sdFeedbackStaffAssignStaffList.fulfilled, (state, action) => {
        state[SD_FEEDBACK_STAFF_ASSIGN_STAFF_LIST].loading = false
        state[SD_FEEDBACK_STAFF_ASSIGN_STAFF_LIST].error = null
        state[SD_FEEDBACK_STAFF_ASSIGN_STAFF_LIST].data = action.payload
      })

    builder
      .addCase(actionCreators.sdFeedbackStaffAssignSubjectAll.pending, state => {
        state[SD_FEEDBACK_STAFF_ASSIGN_SUBJECT_ALL].loading = true
      })
      .addCase(actionCreators.sdFeedbackStaffAssignSubjectAll.rejected, (state, action) => {
        state[SD_FEEDBACK_STAFF_ASSIGN_SUBJECT_ALL].loading = false
        state[SD_FEEDBACK_STAFF_ASSIGN_SUBJECT_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.sdFeedbackStaffAssignSubjectAll.fulfilled, (state, action) => {
        state[SD_FEEDBACK_STAFF_ASSIGN_SUBJECT_ALL].loading = false
        state[SD_FEEDBACK_STAFF_ASSIGN_SUBJECT_ALL].error = null
        state[SD_FEEDBACK_STAFF_ASSIGN_SUBJECT_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.sdFeedbackStaffAssignedEvaluatorsAll.pending, state => {
        state[SD_FEEDBACK_STAFF_ASSIGNED_EVALUATORS_ALL].loading = true
      })
      .addCase(actionCreators.sdFeedbackStaffAssignedEvaluatorsAll.rejected, (state, action) => {
        state[SD_FEEDBACK_STAFF_ASSIGNED_EVALUATORS_ALL].loading = false
        state[SD_FEEDBACK_STAFF_ASSIGNED_EVALUATORS_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.sdFeedbackStaffAssignedEvaluatorsAll.fulfilled, (state, action) => {
        state[SD_FEEDBACK_STAFF_ASSIGNED_EVALUATORS_ALL].loading = false
        state[SD_FEEDBACK_STAFF_ASSIGNED_EVALUATORS_ALL].error = null
        state[SD_FEEDBACK_STAFF_ASSIGNED_EVALUATORS_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.sdFeedbackQuestionAll.pending, state => {
        state[SD_FEEDBACK_QUESTION_ALL].loading = true
      })
      .addCase(actionCreators.sdFeedbackQuestionAll.rejected, (state, action) => {
        state[SD_FEEDBACK_QUESTION_ALL].loading = false
        state[SD_FEEDBACK_QUESTION_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.sdFeedbackQuestionAll.fulfilled, (state, action) => {
        state[SD_FEEDBACK_QUESTION_ALL].loading = false
        state[SD_FEEDBACK_QUESTION_ALL].error = null
        state[SD_FEEDBACK_QUESTION_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.sdFeedbackEvalCampaignCurrent.pending, state => {
        state[SD_FEEDBACK_EVALUATION_CAMPAIGN_CURRENT].loading = true
      })
      .addCase(actionCreators.sdFeedbackEvalCampaignCurrent.rejected, (state, action) => {
        state[SD_FEEDBACK_EVALUATION_CAMPAIGN_CURRENT].loading = false
        state[SD_FEEDBACK_EVALUATION_CAMPAIGN_CURRENT].error = action.payload as AxiosError
      })
      .addCase(actionCreators.sdFeedbackEvalCampaignCurrent.fulfilled, (state, action) => {
        state[SD_FEEDBACK_EVALUATION_CAMPAIGN_CURRENT].loading = false
        state[SD_FEEDBACK_EVALUATION_CAMPAIGN_CURRENT].error = null
        state[SD_FEEDBACK_EVALUATION_CAMPAIGN_CURRENT].data = action.payload
      })

    builder
      .addCase(actionCreators.sdFeedbackEvaluationEvaluateInfo.pending, state => {
        state[SD_FEEDBACK_EVALUATION_EVALUATE_INFO].loading = true
      })
      .addCase(actionCreators.sdFeedbackEvaluationEvaluateInfo.rejected, (state, action) => {
        state[SD_FEEDBACK_EVALUATION_EVALUATE_INFO].loading = false
        state[SD_FEEDBACK_EVALUATION_EVALUATE_INFO].error = action.payload as AxiosError
      })
      .addCase(actionCreators.sdFeedbackEvaluationEvaluateInfo.fulfilled, (state, action) => {
        state[SD_FEEDBACK_EVALUATION_EVALUATE_INFO].loading = false
        state[SD_FEEDBACK_EVALUATION_EVALUATE_INFO].error = null
        state[SD_FEEDBACK_EVALUATION_EVALUATE_INFO].data = action.payload
      })

    builder
      .addCase(actionCreators.sdFeedbackEvaluationStatsOpenEnded.pending, state => {
        state[SD_FEEDBACK_EVALUATION_STATS_OPEN_ENDED].loading = true
      })
      .addCase(actionCreators.sdFeedbackEvaluationStatsOpenEnded.rejected, (state, action) => {
        state[SD_FEEDBACK_EVALUATION_STATS_OPEN_ENDED].loading = false
        state[SD_FEEDBACK_EVALUATION_STATS_OPEN_ENDED].error = action.payload as AxiosError
      })
      .addCase(actionCreators.sdFeedbackEvaluationStatsOpenEnded.fulfilled, (state, action) => {
        state[SD_FEEDBACK_EVALUATION_STATS_OPEN_ENDED].loading = false
        state[SD_FEEDBACK_EVALUATION_STATS_OPEN_ENDED].error = null
        state[SD_FEEDBACK_EVALUATION_STATS_OPEN_ENDED].data = action.payload
      })

    builder
      .addCase(actionCreators.sdFeedbackEvaluationStats.pending, state => {
        state[SD_FEEDBACK_EVALUATION_STATS].loading = true
      })
      .addCase(actionCreators.sdFeedbackEvaluationStats.rejected, (state, action) => {
        state[SD_FEEDBACK_EVALUATION_STATS].loading = false
        state[SD_FEEDBACK_EVALUATION_STATS].error = action.payload as AxiosError
      })
      .addCase(actionCreators.sdFeedbackEvaluationStats.fulfilled, (state, action) => {
        state[SD_FEEDBACK_EVALUATION_STATS].loading = false
        state[SD_FEEDBACK_EVALUATION_STATS].error = null
        state[SD_FEEDBACK_EVALUATION_STATS].data = action.payload
      })

    builder.addCase(actionCreators.sdFeedbackResponseAllClear, state => {
      state[SD_FEEDBACK_RESPONSE_ALL] = defaultState()
    })

    builder.addCase(actionCreators.sdFeedbackStaffAssignPrincipalListClear, state => {
      state[SD_FEEDBACK_STAFF_ASSIGN_PRINCIPAL_LIST] = defaultState()
    })

    builder.addCase(actionCreators.sdFeedbackStaffAssignStaffListClear, state => {
      state[SD_FEEDBACK_STAFF_ASSIGN_STAFF_LIST] = defaultState()
    })

    builder.addCase(actionCreators.sdFeedbackStaffAssignedEvaluatorsAllClear, state => {
      state[SD_FEEDBACK_STAFF_ASSIGNED_EVALUATORS_ALL] = defaultState()
    })

    builder.addCase(actionCreators.sdFeedbackStaffAssignSubjectAllClear, state => {
      state[SD_FEEDBACK_STAFF_ASSIGN_SUBJECT_ALL] = defaultState()
    })

    builder.addCase(actionCreators.sdFeedbackQuestionAllClear, state => {
      state[SD_FEEDBACK_QUESTION_ALL] = defaultState()
    })

    builder.addCase(actionCreators.sdFeedbackEvalCampaignCurrentClear, state => {
      state[SD_FEEDBACK_EVALUATION_CAMPAIGN_CURRENT] = defaultState()
    })

    builder.addCase(actionCreators.sdFeedbackEvaluationEvaluateInfoClear, state => {
      state[SD_FEEDBACK_EVALUATION_EVALUATE_INFO] = defaultState()
    })

    builder.addCase(actionCreators.sdFeedbackEvaluationBySubjectClear, state => {
      state[SD_FEEDBACK_EVALUATION_BY_SUBJECT] = defaultState()
    })

    builder.addCase(actionCreators.sdFeedbackEvaluationStatsOpenEndedClear, state => {
      state[SD_FEEDBACK_EVALUATION_STATS_OPEN_ENDED] = defaultState()
    })
    builder.addCase(actionCreators.sdFeedbackEvaluationStatsClear, state => {
      state[SD_FEEDBACK_EVALUATION_STATS] = defaultState()
    })
  },
})

export const { reducer: sdFeedbackReducer } = sdFeedbackSlice
